import {useEffect} from 'react'
import useTrack from '@hooks/useTrack'

export default function Track() {
  const track = useTrack()
  useEffect(() => {
    track('viewMenu')
  }, []) // Only on mount

  return null
}
